import axios from "axios";
import { getValidToken } from "../../utils/authUtils";
import { BookingFormData } from "./types";

export const bookingApi = {
  getBookingDetailsById: async (id: string, token: string) => {
    // const url = `${process.env.REACT_APP_API_URL}/booking/${id}`;
    // const response = await axios.get(url, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });
    // if (response?.data?.isSuccess) {
    //   return response.data?.message;
    // } else {
    //   return null;
    // }
    return {
      partyName: "Raj Travels Pvt Ltd",
      primaryContact: {
        name: "Rajesh Kumar",
        phone: "+91 9876543210",
        email: "raj@rajtravels.com",
        address: "Mumbai, Maharashtra",
      },
      vehicleNumber: "MH12AB1234",
      odometerReading: 12323,
      tripType: "single",
      route: {
        from: "Mumbai",
        to: "Pune",
      },
      journeyDates: {
        startDate: "2025-05-27",
        startTime: "18:45",
        returnDate: "",
        returnTime: "",
      },
      specialInstructions: "",
      vehicleId: "1",
    };
  },
  getIncomeDetailsById: async (id: string, token: string) => {
    return {
      id: "1",
      incomeType: "fixed",
      amount: 20000,
      overLimitKms: 500,
      overLimitAmount: 30,
      otherIncomes: [
        {
          id: "1",
          type: "other",
          amount: 2000,
          remark: "no",
        },
      ],
      advanceAmount: 0,
      gstPercentage: 18,
      sgstAmount: 1800,
      cgstAmount: 1800,
      totalAmount: 16400,
    };
  },

  createBooking: async (data: BookingFormData) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey`;

      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.data);
      }
    } catch (error) {
      return null;
    }
  },
  getBookingDetails: async (id: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey/${id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  getAllBookings: async (
    filters?: {
      vehicleNumber?: string;
      startDate?: string;
      routeFrom?: string;
      routeTo?: string;
    },
    pagination?: { page?: number; limit?: number }
  ): Promise<{ items: any[]; total: number }> => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey`;
      const queryParams = new URLSearchParams();
      if (filters?.vehicleNumber) {
        queryParams.append("vehicleNumber", filters.vehicleNumber);
      }
      if (filters?.startDate) {
        queryParams.append("startDate", filters.startDate);
      }
      if (filters?.routeFrom) {
        queryParams.append("routeFrom", filters.routeFrom);
      }
      if (filters?.routeTo) {
        queryParams.append("routeTo", filters.routeTo);
      }
      if (pagination?.page !== undefined) {
        queryParams.append("page", String(pagination.page));
      }
      if (pagination?.limit !== undefined) {
        queryParams.append("limit", String(pagination.limit));
      }

      const urlWithParams = queryParams.toString()
        ? `${url}?${queryParams.toString()}`
        : url;

      const response = await axios.get(urlWithParams, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return {
          items: response.data?.data?.items,
          total: response.data?.data?.pagination?.totalRecords,
        };
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return { items: [], total: 0 };
    }
  },
  updateBooking: async (id: string, data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey/${id}`;

      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      throw error;
    }
  },
  getDeletedBookings: async (id: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey/deleted/${id}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  softDeleteBooking: async (id: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey/${id}`;
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },

  getIncomeDetails: async (id: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income/${id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  createIncomeDetails: async (data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  updateIncomeDetails: async (rentalJourneyId: string, data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income/${rentalJourneyId}/bulk`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  getDeletedIncomeDetails: async (id: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income/deleted/${id}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  deleteIncomeDetails: async (data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income/bulk/soft-delete`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },

  createIncomePayment: async (data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income-payments`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },

  getIncomePaymentDetails: async (id: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income-payments/${id}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return [];
    }
  },
  async updateBulkIncomePayment(data: any) {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income-payments`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  async getDeletedIncomePaymentDetails(id: string) {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income-payments/deleted/${id}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  async softDeleteIncomePayment(data: any) {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-income-payments/soft-delete/bulk`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },

  createExpense: async (
    data: any,
    rentalJourneyId: string,
    vehicleId: string
  ) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/${rentalJourneyId}?vehicleId=${vehicleId}`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  createBulkExpense: async (
    data: any,
    rentalJourneyId: string,
    vehicleId: string
  ) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/bulk/${rentalJourneyId}?vehicleId=${vehicleId}`;
      const response = await axios.post(
        url,
        { expenses: data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  getExpenseDetails: async (rentalJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/${rentalJourneyId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  updateBulkExpense: async (
    data: any,
    rentalJourneyId: string,
    vehicleId: string
  ) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/bulk/${rentalJourneyId}?vehicleId=${vehicleId}`;
      const response = await axios.put(
        url,
        { expenses: data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  deleteBulkUpdatedExpense: async (data: any, rentalJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/bulk/soft-delete/${rentalJourneyId}`;
      const response = await axios.post(
        url,
        { expenses: data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  getDeletedExpenseDetails: async (rentalJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/deleted/${rentalJourneyId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return [];
    }
  },

  createBulkExpensePayment: async (data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/bulk/payments/create-payments`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  updatedExpensePayment: async (data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/bulk/payments/update-payments`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
  deleteBulkUpdatedExpensePayment: async (data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-expenses/v2/bulk/payments/delete-payments`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      return null;
    }
  },
};
